import { registerProtectedRoute } from "../route-registry";
import type { RouteConfig, RouteType } from "../types";
import type { ExtractRoutesFromRegistry } from "../route-registry";

// Import all protected route definitions
import { productRoutes } from "./product-routes";
import { chatRoutes } from "./chat-routes";
import { dashboardRoutes } from "./dashboard-routes";
import { orderRoutes } from "./order-routes";
import { saleRoutes } from "./sale-routes";
import { inventoryRoutes } from "./inventory-routes";
import { customerRoutes } from "./customer-routes";
import { operationsRoutes } from "./operations-routes";
import { deliveryFeeRoutes } from "./delivery-fee-route";
import { pickupRoutes } from "./pickup-routes";
import { fulfillmentRoutes } from "./fulfillment-routes";
import { userRoutes } from "./user-routes";
/**
 * Protected routes map - single source of truth for route registration
 * Just add your route here and it will automatically be registered and typed!
 *
 * Example:
 *   myNewRoute: myNewRoutes,
 */
const protectedRoutesMap = {
  product: productRoutes,
  chat: chatRoutes,
  dashboard: dashboardRoutes,
  order: orderRoutes,
  sale: saleRoutes,
  inventory: inventoryRoutes,
  customer: customerRoutes,
  user: userRoutes,
  pickup: pickupRoutes,
  fulfillment: fulfillmentRoutes,
  operations: operationsRoutes,
  deliveryFee: deliveryFeeRoutes,
} as const satisfies Record<string, RouteConfig[] | Record<string, RouteType>>;

// Automatically register all routes from the map
Object.entries(protectedRoutesMap).forEach(([name, routes]) => {
  registerProtectedRoute(name, routes);
});

/**
 * Auto-generated type map for protected routes
 * Automatically extracted from protectedRoutesMap - no manual updates needed!
 * Only includes routes that use Record<string, RouteType> format
 */
export type ProtectedRoutesMap = ExtractRoutesFromRegistry<
  typeof protectedRoutesMap
>;
